"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColumnTransform = exports.draggingContainerStyles = exports.Table = exports.TABLE_Z_INDEX = exports.DraggingShadow = void 0;
exports.scrollShadow = scrollShadow;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// This object is not an attempt to create a design system level z-idex hierarchy and should not be used outside the table.
// It's just here to make the relationship between the different table components is easier to reason about.
var TABLE_Z_INDEX = exports.TABLE_Z_INDEX = {
  BOTTOM: 1,
  MIDDLE: 2,
  TOP: 3
};
function scrollShadow(_ref) {
  var isShadowActive = _ref.isShadowActive,
    _size = _ref.size,
    direction = _ref.direction,
    _ref$isInset = _ref.isInset,
    isInset = _ref$isInset === void 0 ? false : _ref$isInset,
    _ref$isFlat = _ref.isFlat,
    isFlat = _ref$isFlat === void 0 ? false : _ref$isFlat,
    _ref$flatColor = _ref.flatColor,
    flatColor = _ref$flatColor === void 0 ? _colors["default"].white : _ref$flatColor,
    _ref$offsetStart = _ref.offsetStart,
    offsetStart = _ref$offsetStart === void 0 ? 0 : _ref$offsetStart,
    _ref$offsetEnd = _ref.offsetEnd,
    offsetEnd = _ref$offsetEnd === void 0 ? 0 : _ref$offsetEnd;
  var size = isShadowActive ? _size - offsetStart - offsetEnd : 0;
  var dimension = isInset ? 0 : -size;
  var common = (0, _styledComponents.css)(["content:'';position:absolute;transition:120ms;"]);
  var gradientFn = isFlat ? scrollGradientFlat : scrollGradient3D;
  switch (direction) {
    case 'top':
      return (0, _styledComponents.css)(["&:before{", " left:0px;right:0px;top:", "px;height:", "px;", "}"], common, dimension, size, gradientFn(0, isInset, flatColor));
    case 'bottom':
      return (0, _styledComponents.css)(["&:after{", " left:0px;right:0px;bottom:", "px;height:", "px;", "}"], common, dimension, size, gradientFn(180, isInset, flatColor));
    case 'left':
      return (0, _styledComponents.css)(["&:before{", " top:", "px;bottom:", "px;left:", "px;width:", "px;", "}"], common, 0 + offsetStart, offsetEnd, dimension, size, gradientFn(270, isInset, flatColor));
    case 'right':
      return (0, _styledComponents.css)(["&:after{", " top:", "px;bottom:", "px;right:", "px;width:", "px;", "}"], common, 0 + offsetStart, offsetEnd, dimension, size, gradientFn(90, isInset, flatColor));
  }
}
function scrollGradient3D(deg, isInset) {
  return (0, _styledComponents.css)(["background:linear-gradient( ", "", "deg,rgba(0,0,0,0.08) 0%,rgba(0,0,0,0.02) 50%,rgba(0,0,0,0) 100% );"], isInset ? '-' : '', deg);
}
function scrollGradientFlat(deg, isInset, flatColor) {
  return (0, _styledComponents.css)(["background:linear-gradient( ", "", "deg,", " 0%,", " 100% );"], isInset ? '-' : '', deg, flatColor, _colors["default"].transparent);
}
var Table = exports.Table = _styledComponents["default"].table.withConfig({
  displayName: "HBTablestyles__Table",
  componentId: "sc-zs9l5z-0"
})(["width:100%;border-collapse:collapse;border-spacing:0;"]);
var getColumnTransform = exports.getColumnTransform = function getColumnTransform(transform, isPinnedColumn) {
  if (transform && !isPinnedColumn) {
    return "translateX(".concat(transform.x, "px)");
  }
  return 'none';
};
var draggingContainerStyles = exports.draggingContainerStyles = (0, _styledComponents.css)(["transition:", ";position:relative;z-index:", ";"], function (_ref2) {
  var $transition = _ref2.$transition;
  return $transition;
}, function (_ref3) {
  var $isDragging = _ref3.$isDragging;
  return $isDragging ? 1 : null;
});
var DraggingShadow = exports.DraggingShadow = _styledComponents["default"].div.withConfig({
  displayName: "HBTablestyles__DraggingShadow",
  componentId: "sc-zs9l5z-1"
})(["", " height:calc(100% + 1px);display:", ";opacity:0.3;", " ", ""], _mixins.absoluteAll, function (_ref4) {
  var $isDragging = _ref4.$isDragging;
  return $isDragging ? 'block' : 'none';
}, scrollShadow({
  isShadowActive: true,
  size: 15,
  direction: 'right'
}), scrollShadow({
  isShadowActive: true,
  size: 15,
  direction: 'left'
}));
//# sourceMappingURL=HBTable.styles.js.map